import { fbt } from 'fbtee'
import { Bell, Bot, CalendarSync } from 'lucide-react'
import { useTransitionNavigate } from '../../lib/viewTransition'
import { SettingsLinkRow, SettingsSection } from './SettingsSection'

export function NotificationsSection() {
  const navigate = useTransitionNavigate()
  return (
    <SettingsSection title={fbt('Notifications', 'Settings section holding the push notification preferences row')}>
      <SettingsLinkRow
        icon={<Bell className="size-4" />}
        label={fbt('Push notifications', 'Row in Settings linking to the per-category notification toggles')}
        onClick={() => navigate('/settings/notifications')}
      />
    </SettingsSection>
  )
}

export function IntegrationsSection() {
  const navigate = useTransitionNavigate()
  return (
    <SettingsSection
      title={fbt('Calendar & integrations', 'Settings section holding calendar sync and AI agent connections')}
    >
      <SettingsLinkRow
        icon={<CalendarSync className="size-4" />}
        label={fbt('Calendar sync', 'Row in Settings linking to the calendar sync page')}
        onClick={() => navigate('/settings/calendar')}
      />
      <SettingsLinkRow
        icon={<Bot className="size-4" />}
        label={<fbt desc="Row linking to the page for connecting AI agents like Claude in Settings">AI agents</fbt>}
        onClick={() => navigate('/settings/agents')}
      />
    </SettingsSection>
  )
}
